<template lang="pug">
  transition(name="loading")
    .loading(v-if="loading")
      SvgInline(src="/loading.svg")
</template>

<script>
import SvgInline from "@/components/SvgInline.vue";
import {mapState} from 'vuex'
export default {
  name: "Loading",
  components: {
    SvgInline
  },
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed:{
    ...mapState(['loading'])
  }
};
</script>

<style lang="sass">
@import "@/assets/css/mixins.scss"
.loading
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  z-index: 10000
  background-color: black
  overflow: hidden
  display: flex
  justify-content: center
  align-items: center
  @keyframes moveLeft
    0%
      transform: translate(0px)
    100%
      transform: translate(300px)
  @keyframes moveRight
    0%
      transform: translate(0px)
    100%
      transform: translate(-300px)
  .svg_inline
    // height: 100vh
    min-width: 100vw
    width: max(100vmax,1800px)
    height: 100vh
    top: -0vh
    overflow: hidden
    // height: 100%
    transform: initial !important
    @include for_breakpoint(mobile)
      top: -0vh
      width: max(230vmin,1200px)
      height: 140vh
    svg
      overflow: hidden
      g[data-name="row1"]
        animation: moveLeft 10s infinite alternate
      g[data-name="row2"]
        animation: moveRight 11s infinite alternate
      g[data-name="row3"]
        animation: moveLeft 8s infinite alternate
      g[data-name="row4"]
        animation: moveRight 9s infinite alternate
      @keyframes dash 
        to
          stroke-dashoffset: 100

      path
        stroke-dasharray: 100 10 200 10 300 20
        animation: dash 5s linear infinite alternate


.loading-enter-active
  transition: opacity .2s
.loading-leave-active
  transition-delay: 0.2s
  transition: opacity 0.6s

.loading-enter, .loading-leave-to
  opacity: 0


</style>
